import { DebugMode } from './DebugMode.js';
import { LoggerFactory } from './LoggerFactory.js';

export * from './DebugMode.js';
export * from './Label.js';
export * from './Logger.js';
export * from './LoggerFactory.js';
export * from './Message.js';
export * from './QueryParam.js';
export * from './Rgb.js';
export * from './ShortPlacementId.js';
export * from './Status.js';

export const debug = DebugMode.isActive()
  ? LoggerFactory.baseInstance
  : LoggerFactory.Void.baseInstance;

/**
 * @deprecated Use `debug.message(...).log()` instead (or `.info()`, `.warn()`,
 * etc. depending on the context).
 *
 * @see debug
 * @see LoggerFactory
 */
export function debugLog(message: string, ...data: ReadonlyArray<unknown>) {
  debug
    .message(message, ...(data as [unknown, ...ReadonlyArray<unknown>]))
    .log();
}
